<template>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header p-2">
          <h5 v-if="catalogType == 'photo_album'" class="modal-title" style="width:94%;text-align:start">{{$t('Create Album')}}</h5>
          <h5 v-else-if="catalogType == 'package'" class="modal-title" style="width:94%;text-align:start">{{$t('Create Package')}}</h5>
          <h5 v-else class="modal-title" style="width:94%;text-align:start">{{$t('Create Catalog')}}</h5>
          <div style="position: relative;inset-inline-start:4%;bottom: 3px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30"  @click="closeDialog()" fill="currentColor" class="bi bi-x close-icon" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
            </svg>
          </div>
        </div>
        <div class="modal-body">
          <input type="text" ref="folderNameField" v-if="show" class="bg-transparent border rounded text-light form-control input-fields" 
                :placeholder="$t(getplaceholder)" v-model="catalogName" @keyup.enter="createCatalogAction()" @input="restrictSpecialKeyPress">
          <!-- <div v-if="errorMessage" class="config-desc" style="width: 100%;">{{errorMessage}}</div> -->
        </div>
        <div class="modal-footer p-0 primary-btn-style">
          <button @click="closeDialog()" data-dismiss="modal" class="btn btn-outline-secondary mr-2">{{$t('Cancel')}}</button>
          <button class="btn btn-outline-primary ml-1" @click="createCatalogAction()" :class="errorMessage?'disabled':''">{{$t('Save')}} </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions,mapGetters} from "vuex";
import Utils from "../../components.utils.js";
import Constants from "../../components.constants.js";


export default {
  props:["isCatalogExists", "parentCalalog","refreshCatalogList", "catalogType"],
  data: () => ({
    dialog: true,
    catalogName: null,
    folderInfo: {},
    show:false,
    children:[],
    errorMessage:null
  }),
  computed:{
    getplaceholder(){
      if(this.catalogType == "photo_album"){
        return 'Enter Photo Album name'
      }else if(this.catalogType == "package"){
        return 'Enter package name'
      }else{
        return 'Enter Catalog name'
      }
    },
      ...mapGetters("categories", ["getSelectedCategoryInCategoryBrowse"]),
  },
  methods:{
      restrictSpecialKeyPress(event) {
        console.log("Key pressed: ", event);
        this.errorMessage = null;
      },
      closeDialog(){
          this.$emit("close");
      },
      isCatalogExistsCheck(catalogName, pid){
        let catalogInfo = this.children.filter(
                        (catalog)=>(catalog.name==catalogName)&&
                                  (catalog.pid==pid)
                        )
        if (Object.keys(catalogInfo).length !=0){
          return true
        }
        return false
      },
      async updateCatalogChildren(pid){
        let payload={ params: {page:1, pid: pid } }
        let data = await this.getAllAssetsFromServer(payload)
        if (Constants.acceptedStatusCodes.includes(data.statusCode)){
          this.children = data.categories
        }
      },
      createCatalogAction(){
        this.catalogName = this.catalogName.trim();
        if(this.errorMessage){
          return;
        }
        const validation = Utils.isSafeFolderOrFileName(this.catalogName);
        if (!validation.valid) {
          alert(validation.message);
          this.$refs.folderNameField.focus();
          return;
        }
          if(this.catalogName == null || this.catalogName.trim().length == 0){
            if(this.catalogType == "photo_album"){
              alert("Please enter valid Photo Album name");
            }else if(this.catalogType == "package"){
              alert("Please enter valid Package name");
            }else{
              alert("Please enter valid Catalog name");
            }
             this.$refs.folderNameField.focus();
             return false;
          }
          let payload = {}
          payload.asset_type = "catalog"
          payload.catalog_name = this.catalogName;
          let pidExist = false
          if(this.parentCalalog != undefined){
            if('parent_id_path' in this.parentCalalog){
              pidExist = true
              payload.parent_id_path = [this.parentCalalog.parent_id_path[0] + "/" + this.parentCalalog._id]
            }
            else if("pid" in this.parentCalalog){
              pidExist = true
              payload.parent_id_path = [this.parentCalalog.pid + "/" + this.parentCalalog._id]
            }
          }
          if(!pidExist){
            payload.parent_id_path = [this.$route.params.pid + "/" + this.$route.params.catalog_id];
          }
          if(this.catalogType == "photo_album"){
            payload["catalog_type"] = "photo_album"
            this.addPhotoAlbum(payload).then((data)=>{
              if (Utils.isAcceptedStatusCode(data.statusCode)) {
                if (data.message.includes("Failed")) {
                    this.errorMessage = data.message;
                    this.$toast.warning(data.message);
                  } else {
                      this.$toast.success(data.message);
                      if(this.refreshCatalogList == undefined || this.refreshCatalogList == null){
                        this.updateCatalogChildren(this.$route.params.catalog_id)
                      }else{
                        this.refreshCatalogList(this.$route.params.catalog_id)
                      }
                      this.closeDialog();
                  }
              } else {
              this.errorMessage = data.message;
              this.$toast.error(data.message);
              }
            })
          }else if(this.catalogType == "package"){
            payload["catalog_type"] = "package"
            this.addAssetPackage(payload).then((data)=>{
              if (Utils.isAcceptedStatusCode(data.statusCode)) {
                if (data.message.includes("Failed")) {
                    this.errorMessage = data.message;
                    this.$toast.warning(data.message);
                  } else {
                      this.$toast.success(data.message);
                      if(this.refreshCatalogList == undefined || this.refreshCatalogList == null){
                        this.updateCatalogChildren(this.$route.params.catalog_id)
                      }else{
                        this.refreshCatalogList(this.$route.params.catalog_id)
                      }
                      this.closeDialog();
                  }
              } else {
              this.errorMessage = data.message;
              this.$toast.error(data.message);
              }
            })
          }
          else{
            this.addNewCategory(payload).then((data)=>{
              if (Utils.isAcceptedStatusCode(data.statusCode)) {
                if (data.message.includes("Failed")) {
                    this.errorMessage = data.message;
                    this.$toast.warning(data.message);
                  } else {
                      this.$toast.success(data.message);
                      if(this.refreshCatalogList == undefined || this.refreshCatalogList == null){
                        this.updateCatalogChildren(this.$route.params.catalog_id)
                      }else{
                        this.refreshCatalogList(this.$route.params.catalog_id)
                      }
                      this.closeDialog();
                  }
              } else {
              this.errorMessage = data.message;
              this.$toast.error(data.message);
              }
          });
        }
      },
    ...mapActions("assets",["addNewCategory","getAllAssetsFromServer", "addPhotoAlbum", "addAssetPackage"]),
  },
  watch: {
    'show': function (val) {
      if (val) {
          this.$nextTick(() => {
          this.$refs.folderNameField.focus()
        })
      }
    },
    'errorMessage': function(val){
      if(val){
        this.$refs.folderNameField.focus();
      }
    }
  },
  mounted(){
    setTimeout(() => {
      this.show = true;
      this.updateCatalogChildren(this.getSelectedCategoryInCategoryBrowse._id)
    }, 200)
  },
  created(){
  }
}
</script>

<style lang="scss" scoped>
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;
.modal-dialog {
    max-width: 600px;
    width: 600px;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: 227px;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      padding: 2rem;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

.border{
    border: $border-color !important;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    height: 58px;
    .modal-title{
      color:$text-color;
    }
}

.modal-header{
  align-items:center;
  padding: 16px 24px 10px !important;
}

.primary-btn-style{
    margin-top:1%;
    button{
        height: 35px;
        width: 70px;
        font-size:14px;
    }
}

.secondary-btn-style{
  color:$text-color;
}

.key-style {
  color: $dull-text-color;
  width: 30%;
  text-align: start;
  font-size: $input-field-and-label-font-size;
  padding-inline-start: 5px;
  padding-inline-end: 5px;
  margin-top: 3px;
}

.input-fields {
  border: none !important;
  border-bottom: 1px solid $active-blue !important;
  height:30px;
}

.input-fields:focus {
  outline: unset;
  box-shadow:none;
}
.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}
.config-desc{
  color: $danger-color;
  font-size: 14px;
  margin-top: 7px;
  text-align: initial;
}
</style>